import { render, staticRenderFns } from "./EnergyEfficiency.vue?vue&type=template&id=51f201a6&scoped=true&"
import script from "./EnergyEfficiency.vue?vue&type=script&lang=js&"
export * from "./EnergyEfficiency.vue?vue&type=script&lang=js&"
import style0 from "./EnergyEfficiency.vue?vue&type=style&index=0&id=51f201a6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f201a6",
  null
  
)

export default component.exports